// Single source of truth for color tokens that are shared between
// tailwind.config.js (build-time) and React components that need raw hex
// values in inline `style` objects (react-hot-toast, conic-gradient, etc.).
//
// This file lives inside src/ so components can import it without tripping
// CRA's module-scope guard, and it is plain CommonJS so tailwind.config.js
// can require() it directly at build time.
//
// Tailwind exposes these as `bg-feedback-*`, `text-feedback-*`, etc.

// Toast / inline-feedback tokens — consumed by Toast.jsx.
//   - bg / text / border → toast container styling
//   - icon → react-hot-toast iconTheme.primary
const feedback = {
  base: { bg: "#ffffff", text: "#1f2937", border: "#e5e7eb" },
  success: { bg: "#ecfdf5", text: "#065f46", border: "#10b981", icon: "#10b981" },
  error: { bg: "#fef2f2", text: "#991b1b", border: "#ef4444", icon: "#ef4444" },
  info: { bg: "#eff6ff", text: "#1e40af", border: "#3b82f6", icon: "#3b82f6" },
  warning: { bg: "#fffbeb", text: "#92400e", border: "#f59e0b", icon: "#f59e0b" },
};

// Loading spinner conic-gradient stops — used by Loading.jsx.
const spinner = {
  orange: "#FF6B35",
  blue: "#4A90E2",
};

// Sticky horizontal scrollbar (StickyHorizontalScroll) — referenced from
// index.css via Tailwind's theme() function. Slate shades.
const scrollbar = {
  thumb: "#94a3b8", // slate-400
  track: "#f1f5f9", // slate-100
  thumbHover: "#64748b", // slate-500
};

module.exports = { feedback, spinner, scrollbar };
